<template>
  <header
    class="app-layout-header fixed"
    :class="{
      'app-layout-header-tags-view': showTagsView,
      'version-margin-t': showVersionTip,
    }"
  >
    <div class="app-layout-header-inner" :class="{ 'version-fixed-t': showVersionTip}">
      <div class="app-layout-header-nav">
        <div class="app-layout-header-nav-left">
          <hamburger
            @toggleClick="handleToggleSideBar"
            :is-actived="sidebar.opened"
            class="hamburger-container"
          />
          <!-- 面包屑 & 页面描述说明 -->
          <template v-if="pageHeader.length > 0">
            <breadcrumb v-if="pageHeader.includes('breadcrumb')" class="app-breadcrumb hide-in-mobile" />
          </template>
        </div>

        <div class="app-layout-header-nav-right">
          <!-- <el-tooltip
            effect="dark"
            content="使用文档"
            placement="bottom"
            class="hide-in-mobile"
          >
            <a href="https://www.github.com" target="_blank" class="action action-document">
              <icon-svg name="help" />
            </a>
          </el-tooltip> -->

          <el-tooltip
            effect="dark"
            content="下载列表"
            placement="bottom"
          >
            <el-badge :value="downloadText" class="right-box" :class="{ 'download-loading': downloadFlag }" :is-dot="downloadText === '完成'">
              <div @click="handleDownloadList">
                <icon-svg name="icon-download" />
              </div>
            </el-badge>
          </el-tooltip>

          <el-tooltip
            effect="dark"
            content="全屏"
            placement="bottom"
          >
            <span class="action action-fullscreen">
              <fullscreen />
            </span>
          </el-tooltip>

          <!-- 全局通知信息 -->
          <!-- <div class="action">
            <el-popover
              placement="bottom"
              width="350"
              trigger="click"
              @show="handleMessagePopoverShow"
            >
              <messages ref="messages" @syncUnreadCount="handleSyncUnreadCount" />
              <el-badge :hidden="unreadCount === 0" slot="reference" :value="unreadCount" :max="99">
                <icon-svg name="bell" />
              </el-badge>
            </el-popover>
          </div> -->

          <!-- 账户操作 -->
          <div class="action">
            <el-dropdown
              class="action-button"
              trigger="hover"
              placement="top"
            >
              <div class="action-button-inner">
                <icon-svg v-if="!account || !account.avatar" name="user" />
                <img
                  class="avatar"
                  v-if="account && account.avatar"
                  :src="account.avatar"
                  alt=""
                >
                <span class="name">
                  {{ account && account.userName || '-' }}
                  <!-- {{`（${account && account.userId || '-'}）`}} -->
                </span>
              </div>
              <el-dropdown-menu
                slot="dropdown"
                placement="bottom-end"
              >
                <el-dropdown-item disabled>
                  <router-link to="/accounts/edit">基本资料</router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="dialogVisible = true;">
                    {{ '修改密码' }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="handleLogout">
                  <a href="javascript:;">退出登录</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </div>
      </div>
      <tags-view v-if="showTagsView" />
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <el-form
          :model="userInfoForm"
          :rules="userInfoRules"
          ref="userInfoForm"
          label-position="top"
          size="small"
          class="fan-ruleForm"
        >
          <div class="fan-form-item-other">
            <el-form-item
              label="旧密码"
              prop="oldPassword"
            >
              <el-input
                placeholder="请输入旧密码"
                v-model="userInfoForm.oldPassword"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="新密码"
              prop="newPassword"
            >
              <el-input
                placeholder="请输入新密码"
                v-model="userInfoForm.newPassword"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="确认新密码"
              prop="confirmPassword"
            >
              <el-input
                placeholder="请再次输入新密码"
                v-model="userInfoForm.confirmPassword"
              >
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          :loading="repetFlag"
          size="small"
          @click="closeDialog('userInfoForm')"
        >
          取 消
        </el-button>
        <el-button
          type="primary"
          size="small"
          :loading="repetFlag"
          @click="submitDialog('userInfoForm')"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 下载列表 -->
    <download-list-dialog :visible.sync="downloadListShow" />
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Hamburger from '@/components/hamburger';
import Fullscreen from '@/components/fullscreen';
import Breadcrumb from '@/components/breadcrumb';
import { LANGUAGES, PAGE_HEADER, SHOW_TAGS_VIEW } from '@/config';
import TagsView from '../tags-view';
import { modifyPassword } from '@/api/global';
import downloadListDialog from './download-list-dialog';

export default {
  name: 'AppHeader',
  components: {
    Hamburger,
    Fullscreen,
    Breadcrumb,
    TagsView,
    downloadListDialog,
  },
  data() {
    return {
      unreadCount: 0,
      languages: LANGUAGES,
      // 页面头部需要显示的内容
      pageHeader: PAGE_HEADER,
      showTagsView: SHOW_TAGS_VIEW,
      // ---------------修改密码-----------------
      dialogVisible: false,
      repetFlag: false,
      timeStr: 0,
      timer: null,
      userInfoForm: {
        userId: '', // 用户id
        newPassword: '', // 新密码
        confirmPassword: '', // 确认新密码
        oldPassword: '', // 旧密码
      },
      userInfoRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, max: 30, trigger: 'change', message: '请输入6至30位的密码' },
        ],
        newPassword: [
          { required: true, validator: this.validatePass, trigger: 'blur' },
          { min: 6, max: 30, trigger: 'change', message: '请输入6至30位的密码' },
        ],
        confirmPassword: [
          { required: true, validator: this.validatePass2, trigger: 'blur' },
          { min: 6, max: 30, trigger: 'change', message: '请输入6至30位的密码' },
        ],
      },
      downloadListShow: false,
    };
  },
  computed: {
    ...mapGetters('app', [
      'sidebar',
      'showVersionTip',
    ]),
    ...mapGetters('account', [
      'account',
    ]),
    ...mapGetters('global', [
      'downloadText',
      'downloadFlag',
    ]),
  },
  mounted() {
    this.$store.dispatch('global/getDownloadList');
  },
  methods: {
    validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.userInfoForm.confirmPassword !== '') {
          if (this.$refs.userInfoForm) {
            this.$refs.userInfoForm.validateField('confirmPassword');
          }
        }
        callback();
      }
    },
    validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.userInfoForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
    // 取消修改密码
    closeDialog(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.timeStr = 0;
      window.clearInterval(this.timer);
    },
    // 修改密码
    submitDialog(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.userInfoForm.userId = this.account.userId; // 用户id
          this.updatePassword(this.userInfoForm);
        }
      });
    },
    // 修改密码的接口
    async updatePassword(item) {
      try {
        if (this.repetFlag) {
          this.$message({
            message: '正在提交中...',
            type: 'warning',
          });
          return;
        }
        this.repetFlag = true;
        await modifyPassword(item);
        this.dialogVisible = false;
        this.handleLogout();
        this.repetFlag = false;
      } catch (error) {
        console.log(error);
        this.repetFlag = false;
      }
    },

    ...mapActions('account', [
      'logout',
    ]),
    ...mapActions('app', [
      'toggleSidebar',
    ]),
    handleToggleSideBar() {
      this.toggleSidebar();
    },
    /**
     * 设置 语言
     *
     * @param {string} lang 语言 code
     */
    handleSetLang(lang) {
      console.log('switch language to', lang);
    },
    /**
     * 退出登录
     */
    async handleLogout() {
      await this.logout();
      // redirect to login
      this.$router.replace('/login');
    },
    /**
     * 显示全局信息中心
     */
    handleMessagePopoverShow() {
      // 触发加载数据
      this.$refs.messages.getMessages();
    },
    /**
     * 同步未读信息数量
     *
     * @param {number} count 未读数量
     */
    handleSyncUnreadCount(count) {
      this.unreadCount = count;
    },
    // 下载列表
    async handleDownloadList() {
      await this.$store.dispatch('global/getDownloadList');
      this.downloadListShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-layout {
  // 头部
  &-header {
    height: $app-header-height;
    transition: width 0.2s;

    &-inner {
      position: relative;
      z-index: 200;
    }

    &-nav {
      height: $app-header-height;
      // line-height: $app-header-height;
      background-color: $fill-base;
      border-bottom: 1px solid $fill-grey;
      transition: width 0.2s;

      display: flex;
      justify-content: space-between;
      align-items: center;

      &-right {
        color: #808080;
        display: flex;
        align-items: center;

        a {
          color: inherit;
        }
        .right-box {
          cursor: pointer;
          .icon-svg {
            font-size: 24px;
          }
        }
      }
    }

    .hamburger-container {
      padding: 0 20px;
      line-height: $app-header-height;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;
      float: left;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .breadcrumb-container {
      height: $app-header-height;
      line-height: $app-header-height;
      float: left;
    }

    .action {
      padding: 0 20px 0 12px;
      display: inline-block;
      cursor: pointer;
      vertical-align: middle;
      font-size: 20px;
      transition: background-color 0.25s;

      &-button {
        cursor: pointer;
        position: relative;
        font-size: 22px;
        top: 0;
        color: #808080;
        height: $app-header-height;
        display: flex;
        justify-content: center;
        align-items: center;

        &-inner {
          height: 100%;
          display: flex;
          align-items: center;
        }
      }

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }

      .name {
        font-size: 14px;
        margin-left: 8px;
        vertical-align: middle;
        line-height: 1;
      }

      .avatar {
        display: block;
        width: 28px;
        height: 28px;
        border-radius: 100%;
        background-color: rgba(0, 0, 0, 0.05);
        line-height: 1;
      }

      .el-badge {
        line-height: normal;
        position: relative;
        top: -3px;
      }
    }

    // 固定头部
    &.fixed {
      .app-layout-header-inner {
        position: fixed;
        top: 0;
        right: 0;
        // left: $app-sider-width;
        width: calc(100% - #{$app-sider-width});
      }
    }
    &.min {
      .app-layout-header-inner {
        width: calc(100% - #{$app-sider-width-min});
      }
    }
  }

  // 有 tags-view 的头部
  &-header-tags-view {
    height: calc($app-header-height + 34px);
  }
}
</style>

<style lang="scss">
.app-layout-header {
  .fin-input-group__append {
    background: $color-primary;
    color: #ffffff;
    padding: 0 8px;
    border: 1px solid $color-primary;
    font-weight: bolder;
    text-align: center;
    width: 90px;
  }
  .app-layout-header-nav-right {
    .el-badge__content {
      font-size: 8px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      padding: 0 3px;
    }
    .download-loading {
      .el-badge__content.is-fixed {
        right: 18px;
      }
    }
  }
}
</style>
